import React from 'react'
import CIcon from '@coreui/icons-react'
import {
  cilBell,
  cilCalculator,
  cilCalendar,
  cilChartPie,
  cilCursor,
  cilDrop,
  cilEnvelopeOpen,
  cilGrid,
  cilLayers,
  cilMap,
  cilNotes,
  cilPencil,
  cilPuzzle,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
} from '@coreui/icons'
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react-pro'

const _navLeader = [
  {
    component: CNavItem,
    name: 'Dashboard',
    to: '/dashboard',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
    badge: {
      color: 'info-gradient',
    },
  },
  {
    component: CNavGroup,
    name: 'Users',
    icon: <CIcon icon={cilPuzzle} customClassName="nav-icon" />,
    requiredPermission: 'USER',
    items: [
      {
        component: CNavItem,
        name: 'Add Users',
        to: '/adduser',
        requiredPermission: 'USER',
        requiredPrivilege: 'CREATE',
      },
      {
        component: CNavItem,
        name: 'Update Users',
        to: '/updateuser',
        requiredPermission: 'USER',
        requiredPrivilege: 'UPDATE',
      },
      {
        component: CNavItem,
        name: 'View Users',
        to: '/viewuser',
        requiredPermission: 'USER',
        requiredPrivilege: 'VIEW',
      },
      /*{
        component: CNavItem,
        name: 'Group Users',
        to: '/linkusers',
      },*/
    ],
  },
  {
    component: CNavGroup,
    name: 'Payment Links',
    icon: <CIcon icon={cilPuzzle} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'View Referral Link',
        to: '/viewreflink',
        requiredPermission: 'REFERRALLINK',
        requiredPrivilege: 'VIEW',
      },
      {
        component: CNavItem,
        name: 'View Payment Ref Link',
        to: '/viewprlink',
        requiredPermission: 'PAYMENTREF',
        requiredPrivilege: 'VIEW',
      },
      {
        component: CNavItem,
        name: 'View Payment Link',
        to: '/viewpaymentlink',
        requiredPermission: 'PAYMENTLINK',
        requiredPrivilege: 'VIEW',
      },
    ],
  },
  {
    component: CNavItem,
    name: 'Log out',
    to: '/logout',
    icon: <CIcon icon={cilDrop} customClassName="nav-icon" />,
  },
]

export default _navLeader
